const CACHE_KEY_PREFIX = 'optty_customer_info_';

// sessionStorage is scoped to the tab/browsing context, so it survives the same-tab
// `window.location.href` retry navigation but will NOT survive a `window.open`-based redirect.
export const getCachedFormData = (sessionToken?: string): any => {
  if (!sessionToken) return null;
  try {
    const raw = sessionStorage.getItem(`${CACHE_KEY_PREFIX}${sessionToken}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setCachedFormData = (sessionToken: string | undefined, data: any): void => {
  if (!sessionToken) return;
  try {
    sessionStorage.setItem(`${CACHE_KEY_PREFIX}${sessionToken}`, JSON.stringify(data));
  } catch {
    // storage unavailable (privacy mode, quota) - degrade silently
  }
};

export const clearCachedFormData = (sessionToken?: string): void => {
  if (!sessionToken) return;
  try {
    sessionStorage.removeItem(`${CACHE_KEY_PREFIX}${sessionToken}`);
  } catch {
    // storage unavailable - nothing to clear
  }
};
